import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0909f86e"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsOverlay: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Overlay.vue').default,CookiesModal: require('/home/ticketshoplv/public_html/ticketshop.lt/components/cookies/Modal.vue').default,LayoutHeader: require('/home/ticketshoplv/public_html/ticketshop.lt/components/layout/Header.vue').default,LayoutFooter: require('/home/ticketshoplv/public_html/ticketshop.lt/components/layout/Footer.vue').default,Cart: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Index.vue').default,CartMobile: require('/home/ticketshoplv/public_html/ticketshop.lt/components/Cart/Mobile.vue').default})
